import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface DeleteDraftEventResponse {
  deleteDraftEvent: {
    ok: boolean;
  };
}

const DELETE_DRAFT_EVENT_MUTATION = gql`
  mutation DeleteDraftEvent($eventId: Int!) {
    deleteDraftEvent(eventId: $eventId) {
      ok
    }
  }
`;

type PublishDraftEventResponse = {
  publishEvent: {
    ok: boolean;
    zoomSyncFailed: boolean | null;
    event: {
      id: number;
    };
  };
};

const PUBLISH_DRAFT_EVENT_MUTATION = gql`
  mutation PublishDraftEvent($eventId: Int!) {
    publishEvent(eventId: $eventId) {
      ok
      zoomSyncFailed
      event {
        id
      }
    }
  }
`;

const draftEventApi = {
  delete: async (eventId: number): Promise<DeleteDraftEventResponse['deleteDraftEvent']> => {
    return gqlClient
      .request<DeleteDraftEventResponse>(DELETE_DRAFT_EVENT_MUTATION, { eventId })
      .then((res) => res.deleteDraftEvent);
  },
  publish: async (eventId: number): Promise<PublishDraftEventResponse['publishEvent']> => {
    return gqlClient
      .request<PublishDraftEventResponse>(PUBLISH_DRAFT_EVENT_MUTATION, { eventId })
      .then((res) => res.publishEvent);
  }
};

export { draftEventApi };
